<!--
 * @Description: 
-->
<template>
<div class="search-container">
  <el-form :inline="true" :model="filters" :size="size">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.displayClientTypes"
        placeholder="展示终端"
        multiple
      >
        <el-option
          v-for="(item, i) in typeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="上线时间：" class="m-l-14">
        <el-date-picker
            class="date-picker"
            value-format="yyyy-MM-dd"
            size="small"
            v-model="filters.onlineTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
    </el-form-item>
    <el-form-item label="学习时间：">
        <el-date-picker
            class="date-picker"
            value-format="yyyy-MM-dd"
            size="small"
            v-model="filters.studyTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
    </el-form-item>
    </el-form>
    <el-form :inline="true" :size="size" class="search-bottom">
    <el-form-item >
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.subjectName"
        placeholder="专题名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</div>
  
</template>
<script>
import { getSysParamByTypes } from "@/api/sysParam";
import butn from "@/components/button/index";
import { dateStringByday } from '@/utils/timeFormat';
export default {
  name: "search",
  components: {
    butn,
  },
  props: ["placName"],
  data() {
    return {
      size: "small",
      filters: {
        subjectName: '',
        studyStartTime: '',
        studyEndTime: '',
        studyTime:[],
        onlineTime: []
      },
      typeList: [],
    };
  },
  created() {
    this.getSysParamByTypes(["DISPLAY_CLIENT_TYPE"]);
    this.initTime();
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        // res.data["DISPLAY_CLIENT_TYPE"].splice(0, 0, {
        //   paramKey: "",
        //   paramValue: "全部",
        // });
        this.typeList = res.data["DISPLAY_CLIENT_TYPE"] || [];
      });
    },
    initTime() {
      let date = new Date();
      this.filters.studyTime = dateStringByday(date, 7);
      this.filters.onlineTime = dateStringByday(date, 30);
      // this.initData();
    },
    initData() {
      let params = {...this.filters};
      if (params.studyTime && params.studyTime.length > 1) {
        params.studyStartTime = params.studyTime[0]
        params.studyEndTime = params.studyTime[1]
      }
      if (params.onlineTime && params.onlineTime.length > 1) {
        params.onlineStartTime = params.onlineTime[0]
        params.onlineEndTime = params.onlineTime[1]
      }
      delete params['studyTime']
      delete params['onlineTime']
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetName() {
      this.filters = {};
    },
    resetData() {
      this.filters = {};
      this.initTime();
      this.initData();
      // this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style lang="scss" scoped>
.pro_input {
  width: 120px;
  margin-right: 10px;
}
.search-container {
  .search-bottom {
    float: right;
  }
  
}
.date-picker {
  width: 240px;
}

</style>
